import { axiosGet, axiosPost } from './apiClient';
const base = `${process.env.REACT_APP_BASE_URL}/qr-links`;
const qrAdminApi = {
  list: params => axiosGet(base, params),
  save: payload => axiosPost(`${base}/save`, payload),
  status: payload => axiosPost(`${base}/status`, payload),
  scans: (id, params) => axiosGet(`${base}/${id}/scans`, params)
};
export default qrAdminApi;
